// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.page{\r\n\tbackground-color: #f5f5f5;\r\n\theight: 100%;\n}\n.primary_message{\r\n\t--el-message-bg-color: var(--el-color-primary-light-9) !important;\r\n    --el-message-border-color: var(--el-color-primary-light-8) !important;\r\n    --el-message-text-color: var(--el-color-primary) !important;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
